module.exports = __webpack_public_path__ + "static/media/car-1-toowoomba.15fdde0f.png";